function imageCarousel(){
    var $imageCar = [];
    jQuery('.block.block-carousel .swiper-container').each(function(i){
        $imageCar[i] = new Swiper(this, {
            slidesPerView: 'auto',
            freeMode: true,
            loop: true,
            centeredSlides: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });
    });
}
